import { State } from './types';

const initialState: State = {
	projectId: null,
	byId: {},
	byProjectId: {}
};

export default initialState;
